import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="notice">
      <p style={{ marginTop: 0 }}>That page does not exist.</p>
      <Link to="/">Back home</Link>
    </div>
  );
}
